import React, { ReactElement, useEffect, useState } from 'react';

import { createUrl, request } from 'app/utils';

import { Flex, Box, Typography, Button, Section } from 'components';
import { ProductsList, ProductsMyApiResponse, useProducts } from 'features/products';
import { Link, useSearchParams } from 'react-router-dom';

import { useSchool } from 'features/school';

import usestorage from 'app/utils/storage';

const ProductsMyList = (): ReactElement => {
  const [loading, setLoading] = useState(true);
  const [fetched, setFetched] = useState(false);
  const { apiGatewayUrl, schoolUuid } = useSchool();

  const { productsMy, setProductsMy, clearProductsMy } = useProducts();

  const storage = usestorage('localStorage');
  const currentDashboard = storage.get('currentDashboard');

  const [searchParams] = useSearchParams();
  const currentDashboardArea = searchParams.get('dashboardAreaUuid');

  const fetch = async () => {
    setLoading(true);

    await request<ProductsMyApiResponse>({
      url: '/api/v1/School/MyCourses',
      method: 'get',
      baseURL: apiGatewayUrl,
      params: {
        ...(currentDashboard ? { dashboardUuid: currentDashboard } : {}),
        ...(currentDashboardArea ? { dashboardAreaUuid: currentDashboardArea } : {}),
      },
    })
      .then((response) => {
        setProductsMy(response.data);
      })
      .finally(() => {
        setFetched(true);
        setLoading(false);
      });
  };

  const isBenndorf = schoolUuid === 'cfaf550b-037d-45b2-9f84-979fb01185d4';
  const isMeuPlanoCrypto = schoolUuid === '20b929ad-c773-46e2-93de-991988587835';

  let hat = 'Cursos ativos';
  let title = 'Meus cursos';
  let buttonLabel = 'Todos os cursos';

  if (isBenndorf) {
    hat = 'Produtos ativos';
    title = 'Meus produtos';
    buttonLabel = 'Todos os produtos';
  } else if (isMeuPlanoCrypto) {
    hat = 'Ativos';
    title = 'Conteúdos';
    buttonLabel = 'Todos os conteúdos';
  }

  useEffect(() => {
    fetch();

    return () => {
      clearProductsMy();
    };
  }, []);

  return !fetched || productsMy?.length ? (
    <Section flexDirection="column" pt={{ m: 30, t: 60, d: 90 }}>
      <Flex justifyContent="space-between" flexWrap={{ m: 'wrap', d: 'nowrap' }} alignItems="flex-end">
        <Flex flexDirection="column">
          {!!hat && (
            <Typography type="type3" upper mb={1}>
              {hat}
            </Typography>
          )}

          <Typography as="h2" type="type8" fontWeight="bold">
            {title}
          </Typography>
        </Flex>

        <Box width="auto" flexGrow={0} justifyContent="flex-end">
          <Link to={createUrl('productsList')}>
            <Button mt={{ m: 20 }}>{buttonLabel}</Button>
          </Link>
        </Box>
      </Flex>

      <ProductsList loading={loading} products={productsMy} />
    </Section>
  ) : (
    <></>
  );
};

export default ProductsMyList;
